module.exports = __webpack_public_path__ + "images/frontpage_undo@1x.png?53bd49b0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_undo@1x.png
// module id = 666
// module chunks = 7